import { API_BASE_URL } from "../urls.api";

export const GET_ALL_DEVICE_METHOD = "GET";
export const GET_ALL_DEVICE_URL = `${API_BASE_URL}/rooms/devices`;

export const GET_DEVICE_METHOD = "GET";
export const GET_DEVICE_URL = `${API_BASE_URL}/rooms/devices`;

export const CREATE_DEVICE_METHOD = "POST";
export const CREATE_DEVICE_URL = `${API_BASE_URL}/rooms/devices`;

export const UPDATE_DEVICE_METHOD = "PUT";
export const UPDATE_DEVICE_URL = `${API_BASE_URL}/rooms/devices/monitor`;

export const DELETE_DEVICE_METHOD = "DELETE";
export const DELETE_DEVICE_URL = `${API_BASE_URL}/rooms/devices/:id`;

export const GET_DEVICES_WITH_FILTERS_METHOD = "GET";
export const GET_DEVICES_WITH_FILTERS_URL = `${API_BASE_URL}/rooms/devices/by-filters`;

export const GET_DEVICE_BY_MONITOR_ID = `${API_BASE_URL}/rooms/devices/monitor`;

export const REGISTER_DEVICE_METHOD = "POST";
export const REGISTER_DEVICE_URL = `${API_BASE_URL}/devicev3`;

export const SET_DEVICE_ALARMS_ENABLED_URL = `${API_BASE_URL}/rooms/devices/monitor`;
